import React, { useEffect } from "react";
import "./VerificationNoticeModal.css";
import { FaEnvelopeOpenText } from "react-icons/fa";

const VerificationNoticeModal = ({
  isOpen,
  onClose,
  onResend,
  resendDisabled,
  resendHelperText,
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div className="verification-modal-overlay" role="dialog" aria-modal="true">
      <div className="verification-modal-content">
        <div className="verification-modal-icon">
          <FaEnvelopeOpenText />
        </div>
        <h2 className="verification-modal-title">Verificação de email necessária</h2>
        <p className="verification-modal-message">
          Para liberar o login, confirme seu email pelo link enviado.
        </p>

        <div className="verification-modal-alert" role="note">
          <p className="verification-modal-alert-title">Atenção</p>
          <p className="verification-modal-alert-text">
            Se a confirmação não ocorrer em até <strong>24 horas</strong>, o cadastro
            será <strong>excluído automaticamente</strong>.
          </p>
        </div>

        <p className="verification-modal-message">
          Você pode reenviar o email até <strong>2 vezes</strong> dentro desse prazo, com intervalo mínimo de <strong>10 minutos</strong> entre envios.
        </p>
        <div className="verification-modal-actions">
          <button
            className="btn-modern"
            onClick={onResend}
            type="button"
            disabled={!!resendDisabled}
          >
            Reenviar email
          </button>
          <button
            className="btn-modern button-secondary"
            onClick={onClose}
            type="button"
          >
            Entendi
          </button>
        </div>
        {resendHelperText ? (
          <p className="verification-modal-message verification-modal-helper">
            {resendHelperText}
          </p>
        ) : null}
      </div>
    </div>
  );
};

export default VerificationNoticeModal;
